/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */


import {NgModule} from '@angular/core';
import {DateAdapter, MAT_DATE_LOCALE_PROVIDER} from './date-adapter';
import {NativeDateAdapter} from './native-date-adapter';
import {MD_DATE_FORMATS} from './date-formats';
import {MD_NATIVE_DATE_FORMATS} from './native-date-formats';

export {MAT_DATE_LOCALE,MAT_DATE_LOCALE_PROVIDER,DateAdapter} from './date-adapter';
export {MdDateFormats,MD_DATE_FORMATS} from './date-formats';
export {NativeDateAdapter} from './native-date-adapter';
export {MD_NATIVE_DATE_FORMATS} from './native-date-formats';
export class NativeDateModule {static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  providers: [
    {provide: DateAdapter, useClass: NativeDateAdapter},
    MAT_DATE_LOCALE_PROVIDER
  ],
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function NativeDateModule_tsickle_Closure_declarations() {
/** @type {?} */
NativeDateModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
NativeDateModule.ctorParameters;
}

export class MdNativeDateModule {static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [NativeDateModule],
  providers: [{provide: MD_DATE_FORMATS, useValue: MD_NATIVE_DATE_FORMATS}],
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function MdNativeDateModule_tsickle_Closure_declarations() {
/** @type {?} */
MdNativeDateModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
MdNativeDateModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
